import { User } from '@botpress/client'
import { integrationMessagePayloadToBlockPayload, IntegrationMessage, RichBlockMessage } from '@botpress/webchat'
import { ExtendedBridgeMessage } from '~/types'

export function bridgeMessageToRichBlockMessage(message: ExtendedBridgeMessage, user?: User): RichBlockMessage {
  let integrationMessagePayload: IntegrationMessage['payload']
  const supportedTypes = [
    'audio',
    'bloc',
    'carousel',
    'card',
    'choice',
    'dropdown',
    'file',
    'image',
    'location',
    'markdown',
    'text',
    'video',
    'custom',
  ] as const satisfies ExtendedBridgeMessage['type'][]

  if (supportedTypes.includes(message.type)) {
    integrationMessagePayload = {
      type: message.type,
      ...message.payload,
    } as IntegrationMessage['payload']
  } else {
    throw new Error(`Unsupported message type: ${message.type}`)
  }

  const blockMessagePayload = integrationMessagePayloadToBlockPayload(integrationMessagePayload)

  return {
    id: message.id,
    conversationId: message.conversationId,
    authorId: message.userId,
    disableInput: blockMessagePayload.disableInput,
    timestamp: new Date(message.createdAt),
    metadata: message.tags,
    block: blockMessagePayload.payload,
    direction: message.direction,
    sender: {
      name: user?.name ?? 'Anonymous User',
      avatar: user?.pictureUrl ?? '',
    },
  }
}
